import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import GiftFooter from './components/GiftFooter';
import ItemInfo from './components/ItemInfo';
import useGiftItem from './hooks/useGiftItem';

interface Params {
    giftItemId: string;
}

declare module '@stackflow/config' {
    interface Register {
        GiftItemActivity: Params;
    }
}

const GiftItemActivity: ActivityComponentType<'GiftItemActivity'> = ({ params }) => {
    const { giftItemId } = params;
    const giftItem = useGiftItem(giftItemId);
    const { t } = useTranslation('gift');

    return (
        <AppScreen>
            {giftItem && (
                <CtaLayout header={<Header title={t('giftItem.title')}/>}
                    footer={<GiftFooter giftItem={giftItem}/>} >
                    <ItemInfo giftItem={giftItem}/>
                </CtaLayout>
            )}
        </AppScreen>
    );
};

export default GiftItemActivity;
